<template>
  <RfSimpleCard class="p-10">
    <RfInput
      v-model="clicks"
      variant="outlined"
      placeholder="Number of clicks"
      class="w-full max-w-xl"
      title="CPC metering"
      size="large"
      hintMessage="Specify the number of clicks received per month"
    />
  </RfSimpleCard>
</template>

<script>
import RfSimpleCard from "@/components/RfSimpleCard.vue";
import * as Sentry from "@sentry/vue";
import { useToastsStore } from "@/pinia/toastsStore";
import { useAppsStore } from "@/pinia/appsStore";
import RfInput from "@/components/inputs/RfInput.vue";

export default {
  name: "RfAwsMarketplaceSettings",
  components: { RfSimpleCard, RfInput },
  setup: () => ({ toastsStore: useToastsStore(), appsStore: useAppsStore() }),
  data: () => ({ clicks: null }),
  computed: {
    currApp() {
      return this.appsStore.app;
    },
  },
  methods: {
    async updateSettings() {
      try {
        await this.appsStore.updateAwsMarketplace({ appId: this.currApp.id, clicks: this.clicks });
        this.toastsStore.create({ type: "success", body: "Aws Marketplace updated!" });
      } catch (error) {
        this.toastsStore.create({ type: "error", body: error.message });
        Sentry.captureException(error);
      }
    },
  },
};
</script>
